<template>
    <div class="InstagramBusinessChannelGeographics well">
        <h3>Geografi</h3>

        <strong class="text-xs">Byer</strong>
        <bar-chart
            height="160px"
            :colors="['var(--magic-color)']"
            :library="chartConfig"
            :data="channelStat.payload.geography.cities"
        ></bar-chart>

        <strong class="text-xs">Lande</strong>
        <bar-chart
            height="160px"
            :colors="['var(--magic-color)']"
            :library="chartConfig"
            :data="channelStat.payload.geography.countries"
        ></bar-chart>
    </div>
</template>

<style type="text/less" lang="less"></style>

<script type="text/babel">
export default {
    props: ['channelStat'],

    data() {
        return {
            chart: null,
            chartConfig: {
                chart: {
                    marginLeft: 98,
                    marginRight: 50,
                },
                xAxis: {
                    labels: {
                        enabled: true,
                        formatter: function() {
                            return '<div style="width: 80px">' + this.value + '</div>'
                        },
                        useHTML: true,
                    },
                    minorTickLength: 0,
                    tickLength: 0,
                },
                yAxis: {
                    labels: {
                        enabled: false,
                    },
                    min: 0,
                    max: 100,
                    gridLineWidth: 0,
                },
                tooltip: {
                    enabled: false,
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                            format: '{y} %',
                            color: '#616161',
                            inside: false,
                            crop: false,
                            overflow: 'none',
                            style: {
                                fontSize: '13px',
                                textOutline: false,
                                fontWeight: 200,
                                fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
                            },
                        },
                    },
                },
            },
        }
    },
}
</script>
